import { deleteRequestWithBody, getRequest, postRequest, putRequest } from '../../../core/utils/api';
import { type KeycloakContext } from '../../authentication/keycloak/KeycloakProvider';
import Department from '../models/department/department';
import type DepartmentChangeData from '../models/department/department-change-data';
import type GetAllDeparmentsForOfficeResponse from '../models/department/get-all-deparments-for-office-response';
import type Room from '../models/room/room';
import showStatusCodeError from './logging.service';

export const getAllDepartmentsByOfficeId = async (id: string, keycloak: KeycloakContext): Promise<Department[] | undefined> => {
  const apiResponse = await getRequest<Department[]>(`department/all-by-office-id?officeId=${id}`, keycloak);
  if (apiResponse.error) {
    showStatusCodeError(apiResponse.status);
    return undefined;
  }

  try {
    const reponseData: GetAllDeparmentsForOfficeResponse[] = JSON.parse(JSON.stringify(apiResponse.json));

    const departmentData: Department[] = [];
    reponseData.forEach((element) => {
      const department: Department = new Department();
      department.id = element.id;
      department.name = element.name;
      department.rooms = element.rooms;

      departmentData.push(department);
    });

    return departmentData;
  } catch (e) {
    showStatusCodeError(400);
    return undefined;
  }
};

export const createDepartment = async (
  officeId: string,
  departmentToAdd: DepartmentChangeData,
  keycloak: KeycloakContext,
): Promise<string | undefined> => {
  const linkedRoomsIds: string[] = [];
  departmentToAdd.rooms.forEach((room) => {
    linkedRoomsIds.push(room.id ? room.id : '');
  });
  const apiResponse = await postRequest<string>('department', keycloak, {
    OfficeId: officeId,
    name: departmentToAdd.department.name,
    linkedRoomIds: linkedRoomsIds,
  });

  if (apiResponse.error) {
    showStatusCodeError(apiResponse.status);
    return undefined;
  }

  return apiResponse.json;
};

export const deleteDepartment = async (id: string, keycloak: KeycloakContext): Promise<boolean> => {
  const apiResponse = await deleteRequestWithBody('department', keycloak, {
    Id: id,
  });

  if (apiResponse.error) {
    showStatusCodeError(apiResponse.status);
    return false;
  }

  return true;
};

export const updateDepartment = async (
  officeId: string,
  departmentToUpdate: DepartmentChangeData,
  keycloak: KeycloakContext,
): Promise<Room | undefined> => {
  const linkedRoomsIds: string[] = [];
  departmentToUpdate.rooms.forEach((room) => {
    if (room.id !== undefined) {
      linkedRoomsIds.push(room.id);
    }
  });
  const apiResponse = await putRequest<Room>('department', keycloak, {
    officeId,
    id: departmentToUpdate.department.id,
    name: departmentToUpdate.department.name,
    linkedRoomIds: linkedRoomsIds,
  });

  if (apiResponse.error) {
    showStatusCodeError(apiResponse.status);
    return undefined;
  }

  return apiResponse.json;
};
